import { FormEvent, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { api } from '@/lib/api'
import { useAuthStore, type AuthUser } from '@/stores/auth'

export function LoginPage() {
  const token = useAuthStore((s) => s.token)
  const setSession = useAuthStore((s) => s.setSession)
  const navigate = useNavigate()

  const [gebruikersnaam, setGebruikersnaam] = useState('')
  const [wachtwoord, setWachtwoord] = useState('')
  const [bezig, setBezig] = useState(false)
  const [fout, setFout] = useState<string | null>(null)

  if (token) return <Navigate to="/dashboard" replace />

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setFout(null)
    setBezig(true)
    try {
      const resp = await api.post<{ access_token: string; user: AuthUser }>(
        '/api/auth/login',
        { gebruikersnaam, wachtwoord }
      )
      setSession(resp.data.access_token, resp.data.user)
      navigate('/dashboard')
    } catch (err: any) {
      setFout(err?.response?.data?.detail || 'Inloggen mislukt')
    } finally {
      setBezig(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-kh-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="card p-8">
          <div className="text-center mb-6">
            <img src="/logo.svg?v=3" alt="KapitaalHuys" className="h-14 mx-auto" />
            <p className="text-sm text-kh-gold font-medium mt-3 tracking-wide">
              Voorraadfinanciering
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-kh-gray-700 mb-1">
                Gebruikersnaam
              </label>
              <input
                type="text"
                value={gebruikersnaam}
                onChange={(e) => setGebruikersnaam(e.target.value)}
                className="input-field"
                autoFocus
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-kh-gray-700 mb-1">
                Wachtwoord
              </label>
              <input
                type="password"
                value={wachtwoord}
                onChange={(e) => setWachtwoord(e.target.value)}
                className="input-field"
                required
              />
            </div>

            {fout && (
              <div className="rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
                {fout}
              </div>
            )}

            <button
              type="submit"
              disabled={bezig}
              className="btn-primary w-full"
            >
              {bezig ? 'Bezig…' : 'Inloggen'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-kh-gray-400 mt-4">
          © {new Date().getFullYear()} KapitaalHuys — Strategisch bedrijfsadvies
        </p>
      </div>
    </div>
  )
}
